import React from 'react';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';

const DadosGerais = ({ viagem }) => {
  if (!viagem) return null;

  const formatarData = (data) => {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const formatarKm = (km) => {
    if (!km) return '0 km';
    return `${parseFloat(km).toFixed(2)} km`;
  };

  const formatarValor = (valor) => {
    if (!valor || valor === 0) return 'R$ 0,00';
    return `R$ ${parseFloat(valor).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  return (
    <DadosContainer>
      <SectionTitle>Informações Gerais</SectionTitle>
      <Row>
        <Col md={6}>
          <InfoItem>
            <Label>Código de Integração:</Label>
            <Value>{viagem.CodigoIntegracao || '-'}</Value>
          </InfoItem>
        </Col>
        <Col md={6}>
          <InfoItem>
            <Label>Número da Carga:</Label>
            <Value>{viagem.NumeroCarga || '-'}</Value>
          </InfoItem>
        </Col>
      </Row>

      <SectionTitle>Veículo</SectionTitle>
      <Row>
        <Col md={6}>
          <InfoItem>
            <Label>Placa:</Label>
            <Value>{viagem.NumeroPlaca || '-'}</Value>
          </InfoItem>
        </Col>
        <Col md={6}>
          <InfoItem>
            <Label>Número da Frota:</Label>
            <Value>{viagem.NumeroFrota || '-'}</Value>
          </InfoItem>
        </Col>
      </Row>

      <SectionTitle>Motorista</SectionTitle>
      <Row>
        <Col md={12}>
          <InfoItem>
            <Label>Nome:</Label>
            <Value>{viagem.NomeMotorista || '-'}</Value>
          </InfoItem>
        </Col>
      </Row>

      <SectionTitle>Origem e Destino</SectionTitle>
      <Row>
        <Col md={6}>
          <InfoItem>
            <Label>Origem:</Label>
            <Value>
              {viagem.NomeCidadeOrigem || '-'}
              {viagem.SiglaEstadoOrigem && ` / ${viagem.SiglaEstadoOrigem}`}
            </Value>
          </InfoItem>
        </Col>
        <Col md={6}>
          <InfoItem>
            <Label>Destino:</Label>
            <Value>
              {viagem.NomeCidadeDestino || '-'}
              {viagem.SiglaEstadoDestino && ` / ${viagem.SiglaEstadoDestino}`}
            </Value>
          </InfoItem>
        </Col>
      </Row>

      <SectionTitle>Datas e Quilometragem</SectionTitle>
      <Row>
        <Col md={4}>
          <InfoItem>
            <Label>Data de Início:</Label>
            <Value>{formatarData(viagem.DataInicio)}</Value>
          </InfoItem>
        </Col>
        <Col md={4}>
          <InfoItem>
            <Label>Data de Fim:</Label>
            <Value>{formatarData(viagem.DataFim)}</Value>
          </InfoItem>
        </Col>
        <Col md={4}>
          <InfoItem>
            <Label>Total KM Rodado:</Label>
            <Value style={{ fontWeight: 'bold', color: '#007bff' }}>
              {formatarKm(viagem.TotalKmRodado)}
            </Value>
          </InfoItem>
        </Col>
      </Row>

      <SectionTitle>Valores de Frete</SectionTitle>
      <Row>
        <Col md={6}>
          <InfoItem>
            <Label>Valor Frete Líquido:</Label>
            <Value style={{ fontWeight: '500', color: '#28a745' }}>
              {formatarValor(viagem.ValorFreteLiquido)}
            </Value>
          </InfoItem>
        </Col>
        <Col md={6}>
          <InfoItem>
            <Label>Valor Frete Bruto:</Label>
            <Value style={{ fontWeight: '500', color: '#007bff' }}>
              {formatarValor(viagem.ValorFreteBruto)}
            </Value>
          </InfoItem>
        </Col>
      </Row>

      {viagem.NotasFiscais && (
        <>
          <SectionTitle>Notas Fiscais</SectionTitle>
          <Row>
            <Col md={12}>
              <InfoItem>
                <Value>{viagem.NotasFiscais}</Value>
              </InfoItem>
            </Col>
          </Row>
        </>
      )}

      <SectionTitle>Informações de Registro</SectionTitle>
      <Row>
        <Col md={6}>
          <InfoItem>
            <Label>Criado por:</Label>
            <Value>{viagem.NomeUsuarioCriacao || `Usuário ${viagem.UsuarioCriacao}`}</Value>
          </InfoItem>
        </Col>
        <Col md={6}>
          <InfoItem>
            <Label>Data de Criação:</Label>
            <Value>{formatarData(viagem.DataCriacao)}</Value>
          </InfoItem>
        </Col>
      </Row>
    </DadosContainer>
  );
};

export default DadosGerais;

// Estilos
const DadosContainer = styled.div`
  padding: 20px 0;
`;

const SectionTitle = styled.h5`
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  color: #333;
  font-weight: 600;
`;

const InfoItem = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.div`
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 5px;
  font-weight: 500;
`;

const Value = styled.div`
  font-size: 14px;
  color: #212529;
  font-weight: 400;
`;
